import { render, staticRenderFns } from "./LicenseContract.vue?vue&type=template&id=1ba62f98&scoped=true&"
import script from "./LicenseContract.vue?vue&type=script&lang=js&"
export * from "./LicenseContract.vue?vue&type=script&lang=js&"
import style0 from "./LicenseContract.vue?vue&type=style&index=0&id=1ba62f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba62f98",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage});
